import { Routes, Route, Navigate } from 'react-router';
import { BlogPage } from '@/components/pages/BlogPage';
import { BlogPostPage } from '@/components/pages/BlogPostPage';

// Routes are relative to <BrowserRouter basename="/blog"> in main.tsx, so
// "/" here means "/blog" on the live site and ":slug" means "/blog/:slug".
function App() {
  return (
    <Routes>
      <Route path="/" element={<BlogPage />} />
      <Route path="/:slug" element={<BlogPostPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
